import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { TableModule, TableLazyLoadEvent } from 'primeng/table';

import { CampaignService } from '../../services/campaign.service';
import { Campaign, Recipient } from '../../models/campaign';
import { AdminPageHeaderComponent } from '../shared/admin-page-header/admin-page-header.component';

@Component({
  selector: 'app-campaign-details',
  imports: [
    ToastModule,
    TableModule,
    CommonModule,
    AdminPageHeaderComponent
  ],
  providers: [MessageService],
  templateUrl: './campaign-details.component.html',
  styleUrl: './campaign-details.component.scss'
})
export class CampaignDetailsComponent {

  campaign: Campaign | null = null;
  isLoadingCampaign: boolean = false;

  recipients: Recipient[] = [];
  isLoadingRecipients: boolean = false;
  recipientsPage: number = 1;
  rowsPerPage: number = 10;
  totalRecipients: number = 0;

  constructor(
    private route: ActivatedRoute,
    private campaignService: CampaignService,
    private messageService: MessageService,
    private router: Router,
  ) { }

  ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.fetchCampaign(id);
      this.fetchCampaignRecipients(id);
    }
  }

  goBack(): void {
    this.router.navigate(['/dashboard/campaigns']);
  }

  fetchCampaign(id: string) {
    this.isLoadingCampaign = true;

    this.campaignService.retrieveCampaign(id).subscribe({
      next: (response) => {
        this.campaign = response;
        this.isLoadingCampaign = false;
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível buscar a campanha.'
        });
        console.error('Error fetching campaign:', error);
        this.isLoadingCampaign = false;
      }
    })
  }

  fetchCampaignRecipients(id: string) {
    this.isLoadingRecipients = true;

    this.campaignService.listCampaignRecipients(id, this.recipientsPage).subscribe({
      next: (response) => {
        this.recipients = response.results;
        this.totalRecipients = response.count;
        this.isLoadingRecipients = false;
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Não foi possível buscar os usuários dessa campanha.'
        });
        console.error('Error fetching recipients:', error);
        this.isLoadingRecipients = false;
      }
    })
  }

  onLazyLoad(event: TableLazyLoadEvent) {
    const first = event.first ?? 0;
    this.recipientsPage = Math.floor(first / this.rowsPerPage) + 1;
    if (this.campaign) {
      this.fetchCampaignRecipients(String(this.campaign.id));
    }
  }
}
